export const OVERVIEW_GET_TASKS = 'OVERVIEW_GET_TASKS';
export const OVERVIEW_SET_TASKS = 'OVERVIEW_SET_TASKS';
export const OVERVIEW_TOGGLE_MENU = 'OVERVIEW_TOGGLE_MENU';
export const OVERVIEW_SET_DATE = 'OVERVIEW_SET_DATE';
export const OVERVIEW_SET_TYPE = 'OVERVIEW_SET_TYPE';
export const OVERVIEW_TASK_DELETE_START = 'OVERVIEW_TASK_DELETE_START';
export const OVERVIEW_TASK_DELETE_FINISH = 'OVERVIEW_TASK_DELETE_FINISH';
export const OVERVIEW_CHECK_TASKS_IN_PAST = 'OVERVIEW_CHECK_TASKS_IN_PAST';
